import {useId} from "react";
import EditableAutoCompleteBase from "./EditableAutoCompleteBase";

const en = "English";
const es = "Spanish";

const langs = [
    {language: en},
    {language: es},
];

export const langLookup = {
    ENGLISH: en,
    SPANISH: es,
    en: en,
    es: es,
}

export const reverseLookup = {
    [en]: "en",
    [es]: "es",
}

const EditableCardEntryLanguages = ({isEditing, onEdit, baseValue, multiselect = true, requestSubmission = () => {}}) => {
    const randomId = useId();

    return <EditableAutoCompleteBase
        label={`Language${multiselect ? "s" : ""}`}
        isEditing={isEditing}
        displayValue={multiselect ? (baseValue.length ? baseValue.join(",") : <i>None Configured</i>) : baseValue}
        inputID={randomId}
        defaultValue={baseValue}
        items={langs}
        idKey={"language"}
        nameKey={"language"}
        placeholder={"Language"}
        onSelect={onEdit}
        multiSelect={multiselect}
        requestSubmission={requestSubmission}
    />;
}

export default EditableCardEntryLanguages;